var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade xp-video-popup",
      class: { show: _vm.show },
      attrs: {
        id: _vm.id,
        tabindex: "-1",
        "aria-labelledby": "articleModalLabel",
        "aria-modal": "true",
        role: "dialog",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog", attrs: { role: "document" } }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _vm.title
              ? _c(
                  "h3",
                  {
                    staticClass: "modal-title",
                    attrs: { id: _vm.id + "-title" },
                  },
                  [_vm._v(_vm._s(_vm.title))]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "xp-cls cls",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.$emit("close")
                  },
                },
              },
              [_vm._v("Close "), _c("i", { staticClass: "fa fa-angle-right" })]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col col-xs-10" },
                [_vm._t("default")],
                2
              ),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }